import ActivationModal from './ActivationModal';
import ActivationButton from './ActivationModal/ActivationButton';
import LorawanActionsModalMain from './LorawanActionsModalMain';

const LorawanActionsModal = {
  ActionsModal: LorawanActionsModalMain,
  ActivationModal,
  ActivationButton,
};

export default LorawanActionsModal;
